import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import EventEmitter from '../../utils/events'

// Styles
import './mypage.scss'

// import actions
import { editPunchStats, getPunchClockStats, getPunchStatsCurrentUser } from '../../actions/punchclock'
import { getPunchClockInformation } from '../../actions/settings'

// Utils
import { renderFullDate } from '../../utils/time'
import { hasSubscriptionPermission } from '../../utils/auth'
import { translation } from '../../utils/helpers'

// Elements
import Row from '../../shared/elements/row'
import Panel from '../../shared/elements/panel'
import TabBar from '../../shared/elements/tabBar'
import TabItem from '../../shared/elements/tabItem'
import Divider from '../../shared/elements/divider'
import Grid from '../../shared/elements/grid'
import PanelHeader from '../../shared/elements/panelHeader'
import Inline from '../../shared/elements/inline'
import Icon from '../../shared/elements/icon'

import { MyPageIcons } from '../../shared/elements/icons'
// import Header from '../../shared/components/Header'

class MyPage extends Component {

  constructor (props) {
    super(props)
    this.state = {
      punch: {},
      punchStatsCurrentUser: { UserPunchStats: { PunchType: 2 } },
      settings: { PunchInVia: null }
    }
    this._renderMenu = this._renderMenu.bind(this)
    this.getPunchClockStats = this.getPunchClockStats.bind(this)
    this.getPunchStatsCurrentUser = this.getPunchStatsCurrentUser.bind(this)
    this.startStopPunchClock = this.startStopPunchClock.bind(this)
  }

  componentDidMount () {
    this.getPunchClockStats()
    this.getPunchStatsCurrentUser()
    this.props.getPunchClockInformation(this.props.auth.user.ShopId).then(res => {
      this.setState({ settings: res.data })
    })
  }

  /**
   * 0: Pause
   * 1: Working
   * 2: Not punched in
   */
  getPunchClockStats () {
    this.props.getPunchClockStats(0).then((res) => {
      this.setState({
        punch: res.data
      })
    }, () => {
      console.log('Punch err')
    })
  }

  getPunchStatsCurrentUser () {
    this.props.getPunchStatsCurrentUser().then(res => {
      this.setState({
        punchStatsCurrentUser: res.data
      })
    }, () => {
      console.log('Punch err')
    })
  }

  startStopPunchClock (punch) {
    let punchData = {
      UserId: punch.UserId ? punch.UserId : 0,
      PunchType: 0,
      IsManual: true
    }
    // if (punch.Status === 0 || punch.Status === 2) {
    if (this.state.punchStatsCurrentUser.UserPunchStats.PunchType === 0 || this.state.punchStatsCurrentUser.UserPunchStats.PunchType === 2) {
      punchData.PunchType = 1
    } else {
      punchData.PunchType = 2
    }
    this.props.editPunchStats(punchData)
    .then(res => {
      // this.getPunchStatsCurrentUser()
      this.props.getPunchStatsCurrentUser().then(getStatsRes => {
        this.setState({
          punchStatsCurrentUser: getStatsRes.data
        })
        if (getStatsRes.data.UserPunchStats.PunchType === 1) {
          // window.toastr.success(translation('1902'), translation('13424'))
        } else {
          // window.toastr.success(translation('1903'), translation('13424'))
        }
      })
      this.setState({
        punch: res.data
      }, () => {
        if (this.props.router.location.pathname === '/mypage/tasks') {
          EventEmitter.emit('UPDATE_TASKS_MYPAGE')
        }
      })
    })
    .catch(() => {
      window.toastr.error(translation('1904'), translation('216'))
    })
  }

  renderPunchClock () {
    if (!hasSubscriptionPermission(this.props.auth, 20, 12) || !this.props.auth.shopPunchClockActive) return null
    let { punch, settings, punchStatsCurrentUser } = this.state
    if (Object.keys(punch).length === 0) return null
    // Variables
    let punchInAllowed = settings.PunchInVia === 0 || settings.PunchInVia === 2
    let extraClass = 'active'
    // using state.punchStatsCurrentUser to show clock times, because api to update state.punch is not being called after an order is started
    let punchTime = punchStatsCurrentUser.UserPunchStats.LastPunch
    // let punchTime = punch.LastPunchIn
    let punchText = '1900'
    let checkText = '443'
    let image = '/images/icons/Punch-clock-white.png'
    let actionText = '2131'
    let ipRestricted = punch.IsIpRestricted
    let disabled = false
    // if (punch.Status === 0 || punch.Status === 2) {
    if (punchStatsCurrentUser.UserPunchStats.PunchType === 0 || punchStatsCurrentUser.UserPunchStats.PunchType === 2) {
      // punchTime = punch.LastPunchOut
      if (punchInAllowed) {
        actionText = '2130'
      } else {
        disabled = true
      }
      punchText = '1901'
      checkText = '1899'

      extraClass = ''
      image = '/images/icons/Punch-clock-black.png'
    }
    let extraPanelText = ': ' + translation(actionText)
    if (ipRestricted === true || disabled) {
      extraPanelText = ''
      extraClass += ' disabled'
      disabled = true
    }
    // Return
    return (
      <Panel>
        <div className={'punchClock ' + extraClass} onClick={!disabled ? () => this.startStopPunchClock(punch) : null}>
          <Grid cols={['min-content', 1]} align='center' className='pg-px-2'>
            <div className='punchIcon'>
              <img src={image} />
            </div>
            <div className='pg-pb-2'>
              <PanelHeader text={translation(checkText) + extraPanelText} />
              <Divider />
              <Inline spacing={0}>
                <span>{translation(punchText)}</span>
                <span>{renderFullDate(punchTime)}</span>
              </Inline>
            </div>
          </Grid>
        </div>
      </Panel>
    )
  }

  _renderMenu () {
    const renderMyOrders = () => {
      return (
        <Link to='/mypage/orders' activeClassName='active'>
          <Icon icon={MyPageIcons.My_Orders} />
        </Link>
      )
    }
    const renderMyTasks = () => {
      return (
        <Link to='/mypage/tasks' activeClassName='active'>
          <Icon icon={MyPageIcons.My_Tasks} />
        </Link>
      )
    }
    const renderMyMessages = () => {
      return (
        <Link to='/mypage/messages' activeClassName='active'>
          <Icon icon={MyPageIcons.My_Messages} />
        </Link>
      )
    }
    return (
      <TabBar>
        <TabItem>{renderMyOrders()}</TabItem>
        <TabItem>{hasSubscriptionPermission(this.props.auth, 10, 0) && renderMyTasks()}</TabItem>
        <TabItem>{renderMyMessages()}</TabItem>
      </TabBar>
    )
  }

  renderChild () {
    let child = ''
    if (this.props.children !== null) {
      child = React.cloneElement(this.props.children, {
        renderMenu: this._renderMenu,
        getPunchClockStats: this.getPunchStatsCurrentUser
      })
    }
    return child
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    return (
      <div className='mypage__screen'>
        <div className='mypage__screen--inner'>
          <Row>{this.renderPunchClock()}</Row>
          <Row>{this.renderChild()}</Row>
        </div>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getPunchClockStats,
  getPunchStatsCurrentUser,
  editPunchStats,
  getPunchClockInformation
})(MyPage)



// WEBPACK FOOTER //
// ./src/app/pages/MyPage/index.js